import { H1, P } from '../../components/elements/Text';
import Navbar from '../../components/Navbar';
import PageWithAsyncData from '../../components/PageWithAsyncData';
import { useParams } from 'react-router-dom';
import { useGetCompany } from '../../hooks/use-hydra/admin';
import day from 'dayjs';
import utc from 'dayjs/plugin/utc';
import CompanyPageWrapper from '../../components/Admin/CompanyPageWrapper';
import { COMPANY_PAGES } from '../../components/Admin/CompanySideNavigation';
import SubcohortsAndOfficeHours from '../../components/Admin/SubcohortsAndOfficeHours';
import { useGetCompanyOfficeHours } from '../../hooks/use-hydra/admin';
import { ROUTES } from '../../routing';

day.extend(utc);

const NavbarWithBreadcrumbs = ({
  name,
  companyId,
}: {
  name?: string;
  companyId: string;
}) => (
  <Navbar
    breadCrumbs={[
      {
        label: 'Home',
        url: ROUTES.HOME.getPath(),
      },
      {
        label: 'Teams',
        url: ROUTES.ADMIN.COMPANIES.getPath(),
      },
      {
        label: name || 'Company',
        url: ROUTES.ADMIN.COMPANY.getPath({ companyId }),
      },
      {
        label: 'Office Hours',
        url: null,
      },
    ]}
  />
);

export default function OfficeHoursPage() {
  const { id } = useParams<{ id: string }>();
  const {
    data,
    isLoading: isCompanyLoading,
    error,
    refetch,
  } = useGetCompany(parseInt(id));

  const {
    isLoading: isOfficeHoursLoading,
    error: officeHoursError,
    refetch: refetchOfficeHours,
  } = useGetCompanyOfficeHours(parseInt(id));

  const headerText = `${data?.name} Office Hours`;

  return (
    <PageWithAsyncData
      isLoading={isCompanyLoading || isOfficeHoursLoading}
      error={error || officeHoursError}
      retry={() => {
        refetch();
        refetchOfficeHours();
      }}
      noScroll
    >
      <NavbarWithBreadcrumbs name={data?.name} companyId={id} />
      <CompanyPageWrapper
        currentPage={COMPANY_PAGES.OFFICE_HOURS}
        contentStyle={{ width: '100%', overflowX: 'auto', maxWidth: '100%' }}
      >
        <H1>{headerText}</H1>
        <P>
          View the sub-cohort groups and office hours for each mentor. Click on
          any office hours to learn more about learners, track attendance, and
          take notes.
        </P>
        <SubcohortsAndOfficeHours />
      </CompanyPageWrapper>
    </PageWithAsyncData>
  );
}
